import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

import Header from "../../components/header/Header";
import Hero from "../../components/hero/Hero";
import TeamHeroImage from "../../components/hero/teamHero/TeamHeroImage";
import HeroImage from "../../components/hero/HeroImage";
import FooterBottom from "../../components/footer/FooterBottom";
import { InitialState } from "../../store/ArticleStore";
import PopOverMenu from "../../components/ArticleItem/PopOverMenu";

interface BaseLayoutProps {
  children: React.ReactNode;
}

function ArticleLayout({ children }: BaseLayoutProps) {
  const { articleData } = useSelector(
    (state: RootState) => state.articleStore as InitialState
  ); 

  return (
    <>
      <Header>
        <a href="/">
          <img
            src={`${process.env.PUBLIC_URL}/assets/logos/logo-dieligadierockt@2x.webp`}
            alt="Wasserball Logo"
            width="238"
            height="94"
          />
        </a>
      </Header>
      
       {articleData[0]?.isShared && (
        <div
          className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-slate-100 rounded-lg shadow-lg"
          >
            <PopOverMenu articleSlug={articleData[0]?.articleslug} />
          </div>
        </div>
      )}

      <Hero customClass="hero-team">
        <>
          <HeroImage typeImage="team" />
          {articleData && articleData.length > 0 && articleData[0].image && (
            <TeamHeroImage
              picture={articleData[0].image}
              headerimage_copyright_text={articleData[0].image_copyright_text}
            />
          )}
          {children}
        </>
      </Hero>
      <footer className="module_footer-team">
        <FooterBottom />
      </footer>
      
    </>
  );
}

export default ArticleLayout;
